'use client';

import React, { useEffect, useRef } from 'react';
import type { ChatMessage } from '@/lib/api-client';
import MessageBubble from './MessageBubble';

interface MessageThreadProps {
  messages: ChatMessage[];
  currentUserId?: string | null;
}

export default function MessageThread({ messages, currentUserId }: MessageThreadProps) {
  const bottomRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages.length]);

  if (messages.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center p-4">
        <p className="text-sm text-fg-subtle">Send a message to start the conversation.</p>
      </div>
    );
  }

  return (
    <div ref={containerRef} className="flex-1 overflow-y-auto px-3 py-3 space-y-0.5">
      {messages.map((msg) => (
        <MessageBubble
          key={msg.id}
          message={msg}
          isOwn={msg.senderType === 'visitor' || (msg.senderType === 'staff' && msg.senderId === currentUserId)}
        />
      ))}
      <div ref={bottomRef} />
    </div>
  );
}
